import { useEffect } from 'react';
import {
  LOGIN_MODAL_EXPERIMENT,
  LOGIN_MODAL_EXPERIMENT_ID,
  LOGIN_SOURCE_TTU,
  routesToBeInCluded
} from '@cont/Login/constants';
import {
  getIsLoginModalExperiment,
  getIsLoginModalVariation,
  getSetIsNewLoginModal
} from '@stores/selectors/login';
import useLoginStore from '@stores/login/loginStore';
import { useRouter } from 'next/router';
import { segment } from '@actions/analytics';

const useEnableLoginModal = ({ source }) => {
  const router = useRouter();
  const { route } = router;
  const setIsNewLoginModal = useLoginStore(getSetIsNewLoginModal);
  const IsLoginModalExperiment = useLoginStore(getIsLoginModalExperiment);
  const isLoginModalVariation = useLoginStore(getIsLoginModalVariation);
  const sendEvent = ({ IsNewLoginModal }) => {
    const isTTU = source === LOGIN_SOURCE_TTU;
    segment.track('Experiment - User Bucketing', {
      experiment_id: LOGIN_MODAL_EXPERIMENT_ID,
      experiment_name: LOGIN_MODAL_EXPERIMENT,
      curtain_type:
        IsLoginModalExperiment && IsNewLoginModal && !isTTU
          ? 'modal'
          : 'side_curtain',
      variation_name: isLoginModalVariation
    });
  };

  useEffect(() => {
    if (!routesToBeInCluded.includes(route)) {
      setIsNewLoginModal(false);
    } else {
      sendEvent({ IsNewLoginModal: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, setIsNewLoginModal]);
};

export default useEnableLoginModal;
